import { MediaMatcher } from '@angular/cdk/layout';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  AfterViewInit,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';

import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AppConfig } from '../core/services/app-config.service';
import { AuthService } from '../core/services/auth.service';
import { Roles } from '../core/models/roles.enum';

/** @title Responsive sidenav */
@Component({
    selector: 'app-layout',
    templateUrl: 'layout.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppLayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  mobileQuery: MediaQueryList;
  dir = 'ltr';
  green: boolean;
  blue: boolean;
  dark: boolean;
  minisidebar: boolean;
  boxed: boolean;
  danger: boolean;
  showHide: boolean;
  sidebarOpened;
  rsc: any;
  globalAppVersion: string;
  allRoleType = Roles;

  public config: PerfectScrollbarConfigInterface = {};
  private _mobileQueryListener: () => void;

  /**
   * Creates an instance of AppLayoutComponent.
   *
   * @param changeDetectorRef
   * @param media
   * @param appConfig
   * @memberof AppLayoutComponent
   */
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
    private appConfig: AppConfig,
    private authService: AuthService
  ) {
    this.mobileQuery = this.media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => this.changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('change', this._mobileQueryListener);
  }

  ngOnInit() {
    this.rsc = this.appConfig.rsc.layout;
    this.globalAppVersion = require('../../../package.json').version;
  }

  ngAfterViewInit() { }

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
  }

  isRole(role: Roles): boolean{
    return this.authService.isRole(role);
  }

  onBurgerClick() {
    const x = document.getElementById('te-navbar');
    if (x.className === 'te-topnav-row-2') {
      x.className += ' responsive';
    } else {
      x.className = 'te-topnav-row-2';
    }
  }

}
